import { render, staticRenderFns } from "./termCondition.vue?vue&type=template&id=21ab29c1&scoped=true&"
var script = {}
import style0 from "./termCondition.vue?vue&type=style&index=0&id=21ab29c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab29c1",
  null
  
)

export default component.exports